import React from 'react'
import GatsbyLink from '../../GatsbyLink'
import RenderContent from '../../RenderContent'
import { ImagePass } from '../../Image/ImagePass'
import { FaChevronRight } from '../../../images/icons/FaChevronRight'
import './ProductListItem.scss'
import { decodeEntities } from '../../../utils/helpers'

export default class ProductListItem extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeColour: null,
      product: {
        options: {},
      },
    }
  }

  render() {
    const { data, quickAdd } = this.props
    const {
      excerpt,
      title,
      path,
      featured_media,
      featured_image_url,
      date,
      acf,
      product_category,
    } = data
    const { colours, features, material } = acf
    const outdoorUse = features.filter(
      item => item.feature.label === 'Outdoor Use'
    )

    return (
      <div className="post-list-item product">
        <div>
          <div className="tags">
            {product_category && product_category.includes(47) && (
              <div className="tag in-stock">In Stock</div>
            )}
            {product_category && product_category.includes(50) && (
              <div className="tag new">New</div>
            )}
            {product_category && product_category.includes(15) && (
              <div className="tag special">Special</div>
            )}
            {product_category && product_category.includes(121) && (
              <div className="tag custom">Custom</div>
            )}
          </div>
          <div className="image">
            <GatsbyLink to={path} aria-label={title}>
              <ImagePass
                src={
                  this.state.activeColour
                    ? this.state.activeColour.colourImage
                    : featured_image_url?.source_url || featured_media
                }
                className="background"
              />
            </GatsbyLink>
          </div>
          <div className="inner">
            {colours && colours.length > 0 && (
              <div className="colours">
                {colours.map((colour, index) => (
                  <div
                    key={index}
                    // className="colour"
                    className={`colour${
                      this.state.activeColour === colour.colourName
                        ? ' active'
                        : ''
                    }`}
                    style={{
                      backgroundColor: colour.colourHex
                        ? colour.colourHex
                        : null,
                    }}
                    onClick={() => this.setState({ activeColour: colour })}
                  >
                    <span className="colour-name">{colour.colourName}</span>
                  </div>
                ))}
              </div>
            )}
            <span className="title h5">
              <GatsbyLink to={path} aria-label={decodeEntities(title)}>
                {decodeEntities(title)}
              </GatsbyLink>
            </span>
            <span className="material">
              {outdoorUse && outdoorUse.length > 0
                ? 'Indoor/Outdoor'
                : 'Indoor'}
            </span>
          </div>
          <div className="actions">
            {quickAdd && (
              <span className="action" onClick={event => quickAdd(event, data)}>
                Add to quote
              </span>
            )}
            <GatsbyLink to={path} aria-label={title} className="quick">
              View Product
            </GatsbyLink>
          </div>
        </div>
      </div>
    )
  }
}
